var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ht-circular-progress",style:({padding: _vm.lineWidth})},[_c('div',{staticClass:"circular-progress",style:(_vm.getProgress)}),_c('div',{staticClass:"circular-progress-slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }